/**
 * Converts a string to an anchor name
 * @param string - The string to convert
 * @returns The anchor name
 */
export const titleToAnchorName = (string: string) => {
  return string.toString().toLowerCase().replace(/ /g, '-');
};